import React from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import I18n from 'helpers/I18n';

class LoginDropdown extends React.Component {
  render() {
    return (
      <DropdownButton bsStyle="default" title={I18n.t("login_dropdown.title")} id="login-dropdown">
        <MenuItem eventKey="1" href="/auth/vkontakte">
          <span className="fa fa-vk"></span>&nbsp;{I18n.t("login_dropdown.vk")}
        </MenuItem>
        <MenuItem eventKey="2" href="/auth/google_oauth2" >
          <span className="fa fa-google"></span>&nbsp;{I18n.t("login_dropdown.google_plus")}
        </MenuItem>
      </DropdownButton>
    );
  }
}

export default LoginDropdown;




// WEBPACK FOOTER //
// ./app/javascript/components/application/LoginDropdown.jsx